module.exports = __webpack_public_path__ + "static/url-b46c52351692dc1ed35776a8667d4732.png";